import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import CloseButton from "./CloseButton";

import { Link } from "@reach/router";

function Beach(props) {
  const [bacteriaNo, setBacteriaNo] = React.useState(0);

  if (bacteriaNo === 0) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            It's so cool being a beach round here. I get washed twice a day by
            the tide although sometimes that river leaves nasty things. The
            river is my mate but I have to keep reminding it to take the rubbish
            with it. Us Liverpool beaches are all very different, we come in
            different shapes, sizes and kinds I can tell you
          </p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              what they are.
            </button>{" "}
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 1) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            Around Liverpool there are rocky beaches (children love the rock
            pools), sand dunes (sometimes used in golf courses), mudflats (handy
            for mussel farmers) and sandbanks (these tend to irritate the
            boats!).I'm a flat sandy beach, that's my favourite kind, do you
            want to
          </p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              know why?
            </button>{" "}
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 2) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            Lots of bird, mammal and insect folk visit all my beaches but when
            the weather is nice lots of humans come to play on my flat,sandy
            beach. I love the castles and buildings the humans make using my
            sand and they use my surface for games like volleyball and
            sand-surfing. It's such fun. I do have a few gripes though can you
            guess what
          </p>{" "}
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(3);
              }}
            >
              annoys me?
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 3) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            Sometimes the wind can be irritating, blowing my sand all over the
            place, it takes ages for the little humans to put it all back again.
            Some boats release oil which dirties me and is hard to get rid of.
            But the worst thing is all the rubbish left by the humans. It makes
            me look awful and can smell disgusting. Somedays I quite like them
            walking and playing on me, but I really wish they would take
            everything away with them. I have to think of some way to stop this.
            I need to enlist help can you help me{" "}
          </p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(4);
              }}
            >
              set up a plan?
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 4) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            Why don't we join forces and try to change these human's behaviour?
          </p>
        </div>
      </div>
    );
  }
}

export default Beach;
